import React from 'react'
import PropTypes from 'prop-types'
import { GoogleMap, LoadScriptNext, Marker } from '@react-google-maps/api'

const Location = ({ name, lat, lng }) => {
  return (
    <LoadScriptNext googleMapsApiKey={process.env.NEXT_PUBLIC_GOOGLE_API_KEY}>
      <GoogleMap
        mapContainerStyle={{
          width: '100%',
          height: '100%',
        }}
        center={{
          lat: parseFloat(lat),
          lng: parseFloat(lng),
        }}
        zoom={14}
      >
        <Marker
          position={{
            lat: lat,
            lng: lng,
          }}
          title={name}
          icon={{
            url: '/static/images/marker.png',
            // @ts-ignore
            scaledSize: { width: 64, height: 64 },
          }}
        />
      </GoogleMap>
    </LoadScriptNext>
  )
}
Location.propTypes = {
  name: PropTypes.string,
  lat: PropTypes.number,
  lng: PropTypes.number,
}
export default Location
